/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import BobModal from '../../../components/BobModal';
import TextField from '@material-ui/core/TextField';
import DateField from '../../../components/FormFields/DateField';
import ConditionalFormatDropdown from '../../../components/ConditionalFormatDropdown';

import * as classes from './ConditionalFormat.module.css';

const ConditionalFormat = ({
    onClose,
    close,
    open,
    title,
    ...props
}) => {
    const [ showError, setShowError ] = useState(false);

    const handleClose = () => {
        close();
    };

    const handleSubmit = (e)=>{
        let val = props.submitFormat();
        if (val) {
            setShowError(false);
        }
        else setShowError(true);
    };

    const handleAdd = (e, i) => {
        props.addItem();
    };

    const handleDelete= (e, i) => {
        props.removeItem(i);
    };

    const handleChangeTime = (name, i, field) => {
        return (value, event) => {
            if (value) {
                props.updateFormat(value, i, field);
            }
        };
    };

    const getDValue = (key) =>{
        if (typeof(key) === 'string') {
            return new Date(key);
        }
        else {
            return key;
        }
    };

    const handleChange1 = (e,i) =>{
        props.updateFormat(props.fieldType === 'numeric' ? Number(e.target.value) : e.target.value, i, 'field1');
    };

    const handleChange2 = (e,i) =>{
        props.updateFormat(props.fieldType === 'numeric' ? Number(e.target.value) : e.target.value, i, 'field2');
    };
    
    return (
        <div className={'conditional-format'}>
            <div className={classes.formRow} style={{height: 30}}>  
                <div className={classes.Column_1}>
                    Format cells that are
                </div>
                <div className={classes.Column_2}>
                    Value
                </div>
                <div className={classes.Column_3}>
                    And
                </div>
                <div className={classes.Column_4}>
                    With
                </div>
                <div className={classes.Column_5} />
            </div>
            <React.Fragment>
                {props.formatList && props.formatList.length > 0 ?
                    <React.Fragment>
                        {
                            props.formatList.map((item, i) => (
                                <div className={`${classes.formRow} ${item.conflicted ? 'error-row' : ''}`}>  
                                    <div  className={`${classes.Column_1} col-1`}>
                                        <div className={classes.ActionButtonContainer}>
                                            <div className={classes.ActionButtonContainer}>
                                                <ConditionalFormatDropdown
                                                    type="operator"
                                                    fieldType={props.fieldType}
                                                    index = {i}
                                                    val = {item.operator ? item.operator : ''}
                                                    updateFormat={props.updateFormat}
                                                    isFromOptimizationReport={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${classes.Column_2} col-2`} style={props.fieldType === 'date' ? {paddingLeft: 10, paddingRight: 10}: {}}>
                                        {
                                            props.fieldType === 'numeric' ?
                                                <TextField
                                                    type="number" 
                                                    step=".01" 
                                                    onChange={(e) => handleChange1(e,i)}
                                                    id="outlined-basic"
                                                    value={item.field1} 
                                                    variant="outlined"
                                                />
                                                :
                                                <React.Fragment>
                                                    {
                                                        props.fieldType === 'boolean' ?
                                                            <div className={classes.ActionButtonContainer}>
                                                                <div className={classes.ActionButtonContainer}>
                                                                    <ConditionalFormatDropdown
                                                                        type="boolean"
                                                                        fieldType={props.fieldType}
                                                                        index = {i}
                                                                        val = {item.field1 ? item.field1 : ''}
                                                                        updateFormat={props.updateFormat}
                                                                        isFromOptimizationReport={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            :
                                                            <React.Fragment>
                                                                {props.fieldType === 'date' ?
                                                                    <DateField
                                                                        dateFormat={'MM/dd/yyyy h:mm aa'}
                                                                        isClearable={true}
                                                                        label=""
                                                                        margin="dense"
                                                                        name={props.formatKey}
                                                                        onChange={handleChangeTime(props.formatKey, i, 'field1')}
                                                                        showTimeSelect={true}
                                                                        timeFormat={'h:mm a'}
                                                                        timeIntervals={15}
                                                                        value={getDValue(item.field1)}
                                                                        width={'300px'}
                                                                    />
                                                                    :
                                                                    <TextField
                                                                        type="text"  
                                                                        onChange={(e) => handleChange1(e, i)}
                                                                        id="outlined-basic"
                                                                        value={item.field1 || ''} 
                                                                        variant="outlined"
                                                                    />}
                                                            </React.Fragment>
                                                    }
                                                </React.Fragment>
                                        }
                                    </div>
                                    <div className={`${classes.Column_3} col-3`} style={props.fieldType === 'date'?{paddingLeft: 10,paddingRight: 10}:{}}>
                                        {
                                            item.operator === 'Between'?
                                                <React.Fragment>
                                                    {
                                                        props.fieldType === 'date' ?
                                                            <DateField
                                                                dateFormat={'MM/dd/yyyy h:mm aa'}
                                                                isClearable={true}
                                                                label=""
                                                                margin="dense"
                                                                name={props.formatKey}
                                                                onChange={handleChangeTime(props.formatKey, i, 'field2')}
                                                                showTimeSelect={true}
                                                                timeFormat={'h:mm a'}
                                                                timeIntervals={15}
                                                                value={getDValue(item.field2)}
                                                            />:
                                                            <TextField
                                                                type="number" step=".01" id="outlined-basic"
                                                                onChange={(e) =>handleChange2(e,i)}
                                                                value={item.field2} variant="outlined"
                                                            />}
                                                </React.Fragment>:''}
                                    </div>
                                    <div className={`${classes.Column_4} col-4`}>
                                        <div className={classes.ActionButtonContainer}>
                                            <ConditionalFormatDropdown
                                                type="condition"
                                                val = {item.condition?item.condition:''}
                                                index = {i}
                                                updateFormat={props.updateFormat}
                                                isFromOptimizationReport={true}
                                            />
                                        </div>
                                    </div>
                                    <div className={`${classes.Column_5} col-5`}>
                                        <div className={classes.ActionButtonContainer}>
                                            {props.formatList.length - 1 === i ?
                                                <button  className={`circle-white`} onClick={(e) => handleAdd(e,i)}>
                                                    <i className={`fa fa-plus`} aria-hidden="true" />
                                                </button>
                                                :   <button  className={`circle-white`} onClick={(e) => handleDelete(e,i)}>
                                                    <i className={`fas fa-trash-alt`} aria-hidden="true" />
                                                </button>}
                                        </div>
                                    </div>
                                </div>
                            ))} 
                    </React.Fragment>
                    :
                    <div className={classes.formRow}>  
                        <div  className={`${classes.Column_1} col-1`}>
                            <div className={classes.ActionButtonContainer}>
                                <div className={classes.ActionButtonContainer}>
                                    <ConditionalFormatDropdown
                                        type="operator"
                                        fieldType={props.fieldType}
                                        index = {0}
                                        val = {''}
                                        updateFormat={props.updateFormat}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={classes.Column_2}>
                            {
                                props.fieldType === 'numeric' ?
                                    <TextField
                                        type="number" step=".01" onChange={(e) => handleChange1(e,0)}
                                        id="outlined-basic"
                                        variant="outlined"
                                    />:
                                    <TextField
                                        type="text"  onChange={(e) => handleChange1(e,0)}
                                        id="outlined-basic"
                                        variant="outlined"
                                    />
                            }
                        </div>
                        <div className={classes.Column_3}>
                            <TextField id="outlined-basic"  step=".01" variant="outlined" />
                        </div>
                        <div className={`${classes.Column_4} col-4`}>
                            <div className={classes.ActionButtonContainer}>
                                <ConditionalFormatDropdown
                                    type="condition"
                                    val = {''}
                                    index = {0}
                                    updateFormat={props.updateFormat}
                                />
                            </div>
                        </div>
                        <div className={`${classes.Column_5} col-5`}>
                            <div className={classes.ActionButtonContainer}>
                                <button  className={`circle-white`} onClick={(e) => handleAdd(e,0)}>
                                    <i className={`fa fa-plus`} aria-hidden="true" />
                                </button>
                                         
                            </div>
                        </div>
                    </div>
                }
                {
                    showError?
                        <div style={{color: '#f00',fontSize: '1.3rem',padding: 20,height: '4.2rem !important'}} className={classes.formRow}>
                            There is a conflict with the values you have entered, please check and update.
                        </div>
                        :
                        ''
                }
            </React.Fragment>    
        </div>
    );
};

ConditionalFormat.propTypes = {

};

const mapStateToProps = state => {
    return {

    };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(ConditionalFormat);
